import { useState } from 'react';

function BootstrapModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Bootstrap",
      content: [
        "What is Bootstrap?",
        "Why use Bootstrap in web development?",
        "Overview of Bootstrap's features.",
        "Setting up Bootstrap: Using CDN and downloading Bootstrap.",
        "Creating a basic webpage with Bootstrap.",
        "Understanding the mobile-first approach in Bootstrap."
      ]
    },
    {
      title: "Module 2: Bootstrap Grid System",
      content: [
        "Introduction to the Bootstrap Grid System.",
        "Understanding Containers: .container, .container-fluid.",
        "Grid structure: Rows and Columns.",
        "Responsive design with grid breakpoints.",
        "Column sizing: .col-sm, .col-md, .col-lg, .col-xl.",
        "Offsetting columns in the grid: .offset-md-4.",
        "Nest columns within rows to create complex layouts."
      ]
    },
    {
      title: "Module 3: Bootstrap Typography",
      content: [
        "Understanding Bootstrap Typography classes.",
        "Setting text alignment: .text-left, .text-center, .text-right.",
        "Setting font weights: .font-weight-bold, .font-weight-light.",
        "Using text color classes: .text-primary, .text-success.",
        "Responsive typography classes.",
        "Working with headings, paragraphs, and lists in Bootstrap."
      ]
    },
    {
      title: "Module 4: Bootstrap Components",
      content: [
        "Introduction to Bootstrap Components.",
        "Creating Buttons: .btn, .btn-primary, .btn-secondary.",
        "Creating Alerts: .alert, .alert-success, .alert-danger.",
        "Working with Modals: .modal, .modal-dialog.",
        "Using Cards: .card, .card-body, .card-title.",
        "Creating Forms with Bootstrap: .form-control, .form-group.",
        "Using Navigation Bars: .navbar, .navbar-expand-lg.",
        "Creating Dropdowns: .dropdown, .dropdown-toggle."
      ]
    },
    {
      title: "Module 5: Bootstrap Utilities",
      content: [
        "Introduction to Bootstrap Utilities.",
        "Margin and Padding utilities: .m-3, .p-2.",
        "Text utilities: .text-muted, .text-truncate.",
        "Background utilities: .bg-primary, .bg-light.",
        "Display utilities: .d-none, .d-block, .d-flex.",
        "Border utilities: .border, .border-top.",
        "Position utilities: .position-relative, .position-absolute.",
        "Spacing and positioning for responsive layouts."
      ]
    },
    {
      title: "Module 6: Bootstrap Forms",
      content: [
        "Creating Basic Forms with Bootstrap.",
        "Input fields: .form-control, .form-group.",
        "Form labels: .form-label, .form-text.",
        "Form validation classes: .is-valid, .is-invalid.",
        "Custom Form Controls: Checkboxes, Radios, Select.",
        "Creating Inline Forms with .form-inline.",
        "Form Grid Layout with .col-form-label.",
        "Form Layouts: Horizontal, Vertical."
      ]
    },
    {
      title: "Module 7: Bootstrap Navigation and Pagination",
      content: [
        "Creating Navigation Bar: .navbar, .navbar-nav, .navbar-expand.",
        "Working with Pagination: .pagination, .page-item, .page-link.",
        "Creating Breadcrumbs: .breadcrumb, .breadcrumb-item.",
        "Navbar with Links and Dropdowns.",
        "Using Navs: .nav, .nav-item, .nav-link.",
        "Creating Pills and Tabs with Navs.",
        "Sticky Navigation with .sticky-top."
      ]
    },
    {
      title: "Module 8: Bootstrap Grid Layouts and Responsiveness",
      content: [
        "Creating Multi-Column Layouts with Bootstrap.",
        "Grid System for responsive design.",
        "Building responsive layouts with columns of different widths.",
        "Column resizing with grid breakpoints.",
        "Media Queries for responsive design in Bootstrap.",
        "Handling smaller devices with mobile-first design approach.",
        "Designing responsive cards and lists."
      ]
    },
    {
      title: "Module 9: Customizing Bootstrap",
      content: [
        "Customizing Bootstrap using Bootstrap variables.",
        "Modifying default theme colors and typography.",
        "Using SASS to customize Bootstrap.",
        "Building custom Bootstrap themes.",
        "Overriding Bootstrap styles with custom CSS.",
        "Using the Bootstrap Build Tool to generate a custom version of Bootstrap."
      ]
    },
    {
      title: "Module 10: Bootstrap JavaScript Plugins",
      content: [
        "Introduction to Bootstrap's JavaScript Plugins.",
        "Working with Popovers and Tooltips.",
        "Using Carousels with Bootstrap: .carousel, .carousel-item.",
        "Handling modals with .modal, .modal-body.",
        "Creating dropdowns with JavaScript functionality.",
        "Using Collapse and Accordion: .collapse, .accordion-item.",
        "Using the Scrollspy plugin for navigation highlighting."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Bootstrap Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BootstrapModule;
